import { lazy } from 'react';
import { ModuleConfig } from '@/types';

const moduleRegistry: Record<string, ModuleConfig> = {
  packshot: {
    id: 'packshot',
    name: 'Product Session',
    icon: 'packshot',
    component: lazy(() => import('@/modules/packshots/PackshotsModule')),
    defaultParams: {
      imageStyle: 'photo',
      sceneType: 'product_packshot',
      packshotStyle: 'studio',  // Default: studio (can be changed internally)
      aspectRatio: 'auto',
      hasLocation: false,
      hasPeople: false,
      hasProductImage: true,
      hasReferenceImage: true
    }
  },
  
  photo: {
    id: 'photo',
    name: 'Real Photo',
    icon: 'photo',
    component: lazy(() => import('@/modules/photos/PhotosModule')),
    defaultParams: {
      imageStyle: 'photo',
      aspectRatio: 'auto',
      sceneTypes: ['action', 'abstract'],
      hasLocation: true,
      hasPeople: true,
      hasCamera: true,
      hasReferenceImage: true,
      hasSmartObject: true
    }
  },
  
  mockup: {
    id: 'mockup',
    name: 'Digital Mockup',
    icon: 'mockup',
    component: lazy(() => import('@/modules/mockups/MockupsModule')),
    defaultParams: {
      imageStyle: 'photo',
      sceneType: 'mockup',
      aspectRatio: 'auto',
      hasReferenceImage: true
    }
  },
  
  infographic: {
    id: 'infographic',
    name: 'Infographic',
    icon: 'infographic',
    component: lazy(() => import('@/modules/infographics/InfographicsModule')),
    defaultParams: {
      imageStyle: 'infographic',
      aspectRatio: '16:9',
      hasReferenceImage: true
    }
  },
  
  illustration: {
    id: 'illustration',
    name: 'Illustration',
    icon: 'illustration',
    disabled: true,
    component: lazy(() => import('@/modules/illustrations/IllustrationsModule')),
    defaultParams: {
      imageStyle: 'illustration',
      aspectRatio: 'auto',
      hasReferenceImage: true
    }
  },

  // HIDDEN: Icons module temporarily disabled
  // icon: {
  //   id: 'icon',
  //   name: 'Icons',
  //   icon: 'icon',
  //   component: lazy(() => import('@/modules/icons/IconsModule')),
  //   defaultParams: {
  //     imageStyle: 'icon',
  //     aspectRatio: '1:1',
  //     hasReferenceImage: true
  //   }
  // }
};

export default moduleRegistry;
